import { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { FlightOutlined } from "@mui/icons-material";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useAuthContext } from "../../context/auth";
import { ConfirmDialog } from "../dialogKit";

const DeleteAirport = ({ id, name, onDeleted }) => {
  const axiosPrivate = useAxiosPrivate();
  const { auth } = useAuthContext();

  const [show, setShow] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    if (!auth) {
      setError("You must be logged in");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      await axiosPrivate.delete(`/api/airports/${id}`);

      setShow(false);
      onDeleted?.(id); // let the parent remove the row
    } catch (err) {
      console.error("Error deleting airport:", err);

      if (err.response?.status === 404) {
        // Already gone on the server, so sync the UI
        setShow(false);
        onDeleted?.(id);
        return;
      }

      setError(err.response?.data?.error || "Delete failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Tooltip title="Delete airport">
        <IconButton
          color="secondary"
          size="small"
          onClick={() => { setError(null); setShow(true); }}
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>

      <ConfirmDialog
        open={show}
        onClose={() => setShow(false)}
        onConfirm={handleDelete}
        busy={loading}
        error={error}
        title="Delete airport?"
        message="The airport is removed from the map for every user."
        item={name}
        itemIcon={FlightOutlined}
        confirmLabel="Delete airport"
      />
    </>
  );
};

export default DeleteAirport;
